import React from 'react'
import BillingComponent from '@components/pages/Billing/Billing.component'

function BillingPage(): React.ReactElement {
  return <BillingComponent />
}

export default BillingPage
